import { PayloadAction, createAction, createSelector, createSlice } from "@reduxjs/toolkit";
import { AccountProfile, ReduxAccountState, UpdateProfileProps } from "../types";
import { withPayloadType } from "../../shared/utils";
import { ReduxSliceState } from "../../shared/types";
import { ReduxRootState } from "../../shared/redux/store";

const initialState: ReduxAccountState = {
    state: 'BUSY',
    profile: undefined,
};

export const loadProfile = createAction('account/loadProfile');
export const updateProfile = createAction('account/updateProfile', withPayloadType<UpdateProfileProps>());

const accountSlice = createSlice({
    name: 'account',
    initialState,
    reducers: {
        setState: (state, action: PayloadAction<ReduxSliceState>) => {
            state.state = action.payload;
        },
        setProfile: (state, action: PayloadAction<AccountProfile>) => {
            state.profile = action.payload;
        },
    }
});

export default accountSlice;
const selectSelf = (state: ReduxRootState) => state.account;
export const selectProfileState = createSelector(selectSelf, self => self.state);
export const selectProfileStateBusy = createSelector(selectProfileState, state => state === 'BUSY');
export const selectProfile = createSelector(selectSelf, self => self.profile);
//export const selectAccountState = createSelector(selectSelf, self => self.orderState);
//export const selectOrdersSearchOrderIsBusy = createSelector(selectOrdersSearchOrderState, orderState => orderState === 'BUSY');